import MapControl from './index.vue'

export default MapControl
